import React, { useEffect } from "react";
import { connect } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { Link } from "react-router-dom";
import moment from "moment";

const BoekingenTabelDetail = ({ bedrijven }) => {

  const columns = [
    {
      dataField: "bedrijven.promotie.title",
      text: "Titel",
    },
    {
      dataField: "bedrijven.promotie.discription",
      text: "beschrijving",
      formatter: (cell, row) => {
        const cleanText = cell.replace(/<[^>]+>/g, ""); // Verwijder HTML-tags
        return cleanText.substring(0, 50) + "...";
      },
    },
    {
      dataField: "status",
      text: "Status",
      headerStyle: (colum, colIndex) => {
        return { width: "150px" };
      },
    },
    
    {
      text: "Acties",
      dataField: "_id",
      formatter: (cellContent, row) => {
        return (
          <span>
            <Link className="btn btn-info" to={"/vacatures/bedrijven/" + row.bedrijven._id+"/vacatures"}>
              Vacatures
            </Link>
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "250px" };
      },
    },
  ];

  return (
    <ToolkitProvider
      keyField="_id"
      data={bedrijven}
      columns={columns}
      search={{
        searchFormatted: true,
      }}
    >
      {(props) => (
        <div>
          <Search.SearchBar placeholder="Zoeken" {...props.searchProps} />
          <hr />
          <BootstrapTable wrapperClasses="table-responsive-md" pagination={paginationFactory()} {...props.baseProps} />
        </div>
      )}
    </ToolkitProvider>
  );
};

function mapStateToProps(state) {
  return { username: state.auth.user, boekingen: state.boekingen.items };
}

export default connect(mapStateToProps, {})(BoekingenTabelDetail);
